import { render, staticRenderFns } from "./AddSupplierListModal.vue?vue&type=template&id=1a9a2bbe&scoped=true&"
import script from "./AddSupplierListModal.vue?vue&type=script&lang=js&"
export * from "./AddSupplierListModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplierListModal.vue?vue&type=style&index=0&id=1a9a2bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a2bbe",
  null
  
)

export default component.exports